"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DefaultListener_1 = require("./listener/DefaultListener");
var Connection_1 = require("./connection/Connection");
var Gaia = /** @class */ (function () {
    function Gaia(listener) {
        this.listener = new DefaultListener_1.DefaultListener(listener || null);
    }
    /**
     * Connect the client to AIOS.
     *
     * @param options the ID of the identity
     */
    Gaia.prototype.connect = function (options) {
        var _this = this;
        return new Promise(function (resolve) { return resolve(new Connection_1.Connection(options, _this.listener)); });
    };
    return Gaia;
}());
exports.Gaia = Gaia;
